import React from 'react';
import './PhoneContainer.css';

function PhoneContainer({ children }) {
  return (
    <div className="phone-container">
      <div className="phone-wrapper">
        <div className="phone-content">
          {children}
        </div>
      </div>
      <div className="rotation-prompt">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
          <path d="M12 18h.01" />
        </svg>
        <p>Please rotate your device to portrait mode</p>
      </div>
    </div>
  );
}

export default PhoneContainer; 